@if (crumbs().length > 1) {
  <nav i18n-aria-label aria-label="Navigationspfad" class="mt-3">
    <ol class="breadcrumb">
      @for (crumb of crumbs(); track $index; let last = $last) {
        @if (last) {
          <li class="breadcrumb-item active" aria-current="page">{{ crumb.label }}</li>
        } @else if (crumb.link) {
          <li class="breadcrumb-item">
            <a [routerLink]="crumb.link">{{ crumb.label }}</a>
          </li>
        } @else {
          <li class="breadcrumb-item is-static">{{ crumb.label }}</li>
        }
      }
    </ol>
  </nav>
}
